'use client';

import type { ComponentProps } from 'react';

import { Progress as ProgressPrimitive } from '@base-ui-components/react/progress';
import { clsxm } from '@vs-shop/utils';

export type ProgressProps = ComponentProps<typeof ProgressPrimitive.Root>;

export function Progress({ className, ...props }: ProgressProps) {
  return (
    <ProgressPrimitive.Root data-slot="progress" className={clsxm(className)} {...props}>
      <ProgressPrimitive.Track
        data-slot="progress-track"
        className="bg-foreground/10 relative h-1 w-full overflow-hidden rounded-full"
      >
        <ProgressPrimitive.Indicator
          data-slot="progress-indicator"
          className="bg-primary h-full transition-[width]"
        />
      </ProgressPrimitive.Track>
    </ProgressPrimitive.Root>
  );
}
